// import API from '@/api/api'
import rootConfig from '../global/UrlPathRootConfig.js';
import { v4 as uuidv4 } from 'uuid';
import axios from 'axios';
import md5 from 'md5'
// import { Message, Spin } from 'iview'
import router from '@/router'
// import cookie from './cookie'
//1.系统未登录之前的请求
const status = {
    400: '请求出现错误',
    401: '没有提供认证信息',
    403: '没有权限',
    404: '请求内容不存在',
    405: '请求方式错误',
    406: '请求的资源并不符合要求',
    408: '客户端请求超时',
    413: '请求体过大',
    415: '类型不正确',
    416: '请求的区间无效',
    500: '服务器错误',
    501: '请求还没有被实现',
    502: '网关错误',
    503: '服务暂时不可用',
    504: '服务连接失败',
    505: '请求的 HTTP 版本不支持'
}
// 创建axios实例
let cancel,
    promiseArr = {}
let msg = ''
const CancelToken = axios.CancelToken
const service = axios.create()
// service.defaults.withCredentials = true

function destroy(url) {
    delete promiseArr[url]
    if (!Object.keys(promiseArr).length) {
        // Spin.hide()
    }
}
// request拦截器
service.interceptors.request.use(
    (config) => {
        // 请求参数-网关的版本
        config.headers['x-gw-version'] = `${rootConfig.x_gw_version}`
        config.headers['x-host-app-id'] = `${rootConfig.x_host_app_id}`
        // 网关请求AppId
        config.headers['x-app'] = `${rootConfig.x_app}`
        // 网关请求API
        config.headers['x-api'] = config.x_api == undefined ? "" : config.x_api
        // config.headers['x-api'] = "engine.login.loginByAccountPswd"
        // 请求头时间戳
        let datestr = (Date.now()).toString()
        config.headers['x-ts'] = datestr
        // UUID值
        let uuid = (uuidv4()).toString()
        config.headers['x-nonce'] = uuid
        // WEB, IOS，ANDROID，IPAD，WINDOWS，MAC
        config.headers['x-client'] = `${rootConfig.x_client}`
        // 请求环境：TEST(测试)、PRE（预发）、PROD（生产,不传时的默认值
        config.headers['x-stage'] = `${rootConfig.x_stage}`
        // 设备ID，该值在启用了加解密插件功能时需要（非必填）
        config.headers['x-did'] = ''
        // App版本号，在移动端app接入时需要，后期会配合灰度插件使用（非必填）
        config.headers['x-app-version'] = ''
        // 只在网关开启对应api的t验证token开关时需要（非必填）
        // 需要参与签名的头信息，用英文逗号分隔，公共参数都需要参与签名（非必填）
        // 签名值（非必填）
        let usertoken = window.$cookies.get('engine-token')
        //1、依照：
        // x-gw-version，x-app，secretKey，api，x-ts，x-nonce，x-client
        // 的顺序加上x-sign-headers定义的参与签名头信息按顺序取值，然后对参数值（为空不参与签名）进行拼装（即value1&value2&value3…）拼接成字符串tempString；
        // 2、对tempString进行MD5运算，得到32位sign；
        // 将sign作为x-sign的值放入请求头中。
        let x_sign = `${rootConfig.x_gw_version}&${rootConfig.x_app}&${rootConfig.secretKey}&${config.x_api}&${datestr}&${uuid}&${rootConfig.x_client}`
        if (usertoken) {
            config.headers['x-token'] = `${usertoken}`
            config.headers['x-sign-headers'] = `x-token`
            md5("fsdf")
            config.headers['x-sign'] = md5(x_sign + `&${usertoken}`)
        }
        else {
            config.headers['x-token'] = ""
            config.headers['x-sign-headers'] = ""
            config.headers['x-sign'] = md5(x_sign)
        }
        // 添加全局的loading...
        let token = window.$cookies.get('PIECloud-Token')
        if (token) config.headers.Authorization = `${token}`
        if (!Object.keys(promiseArr).length) {
            // Spin.show() // 不建议开启，因为界面不友好
        }
        promiseArr[config.url] = true
        return config
    },
    (error) => {
        // Do something with request error
        // router.push({
        // 	path: '/login'
        // })
        console.log('error: ', error)
        return Promise.reject(error)
    }
)

// response 拦截器
service.interceptors.response.use(
    (response) => {
        const { data, status, url } = response
        destroy(url)
        /**
         * code为非20000是抛错 可结合自己业务进行修改
         */
        // Spin.hide() // 不建议开启，因为界面不友好
        const res = response.data
        if (status && status !== 200) {
            console.log('res: ', res)
        }

        //New token logic: status wont been set as 401 when token timeout as soon as a while,
        //a new header property named 'X-PIE-Token' will be recived for replace old token.
        //If token timeout's time out range of limit,then response got a status code 401.
        const newToken = response.headers["X-PIE-Token"];
        if (newToken) {
            localStorage.setItem('PIECloud-Token', newToken);
            console.warn("New token has been set \n");
        }

        return {
            data,
            status
        }
    },
    (error) => {
        if ((error.response ? error.response.status : error.code) == 401) {
            window.sessionStorage.removeItem("PIECloud-Token")
            window.sessionStorage.removeItem("userName")
            window.sessionStorage.removeItem("userId")
            // window.location = jumpLoginIP + "/#/login?login=true";
            // router.push({ path: "/login" })
        }
        // Spin.hide() // 不建议开启，因为界面不友好
        console.dir(error)
        // Message.error(status[error.response.status])
        console.group(error.config.url)
        console.log(
            '%cdata：' + (error.response == undefined ? error.name : error.response.config.data),
            'background-color:#159E5C;color:white;height:16px;border-radius:4px;padding:2px 4px;'
        )
        console.log(
            '%cerror：' + (error.response ? error.response.data.error : error.message),
            'background-color:#DC5145;color:white;height:16px;border-radius:4px;padding:2px 4px;'
        )
        console.log(
            '%cstatus：' + (error.response ? error.response.status : error.code),
            'background-color:#FDCC41;color:white;height:16px;border-radius:4px;padding:2px 4px;'
        )
        console.log(
            '%cmessage：' + error.message,
            'background-color:#4D8BF2;color:white;height:16px;border-radius:4px;padding:2px 4px;'
        )
        console.log('%c-------------------------------------------------------------------', 'font-weight:700;')
        // console.groupEnd()
        const errordata = error.response
        return { errordata }
    }
)
export const req = {
    //get请求
    get(url, param = {}, x_api) {

        delete param._rowKey
        delete param._index
        return new Promise((resolve, reject) => {
            service({
                method: 'get',
                url,
                x_api,
                params: param,
                cancelToken: new CancelToken((c) => {
                    cancel = c
                })
            })
                .then((res) => {

                    console.log('res: ', res)
                    if (!res.data) {
                        resolve(res)
                        return
                    }
                    if (res.status == 200 || res.data instanceof Array) {

                        console.groupCollapsed(url + '  %cGET', 'font-weight:900;color:red;')
                        if (res.data instanceof Array) {
                            res.data.map((v) => {
                                console.log(
                                    '%cdataObj：' + JSON.stringify(v, null, 2),
                                    'background-color:#fff;color:black;height:16px;border-radius:4px;padding:2px 4px;'
                                )
                            })
                        } else if (res.data instanceof Array) {
                            console.log(
                                '%cdataObj：' + JSON.stringify(res.data, null, 2),
                                'background-color:#fff;color:black;height:16px;border-radius:4px;padding:2px 4px;'
                            )
                        } else if (res.data instanceof String) {
                            console.log(
                                '%cdata：' + res.data,
                                'background-color:#fff;color:black;height:16px;border-radius:4px;padding:2px 4px;'
                            )
                        } else {
                            console.log(
                                '%cdata：' + res.data,
                                'background-color:#fff;color:black;height:16px;border-radius:4px;padding:2px 4px;'
                            )
                        }
                        console.log(
                            '%c-------------------------------------------------------------------',
                            'font-weight:700;'
                        )
                        console.groupEnd()
                        if (res.data instanceof String) {
                            // Message.success(res.data)
                        }
                        resolve(res)
                    } else {
                        // Message.error(res.data.msg || '错误')
                        reject(res.data.msg)
                    }
                })
                .catch((error) => {
                    if (process.env.NODE_ENV === 'production') return
                    console.dir(error)
                    console.group('%c' + url + '  GET', 'font-weight:900;color:red;')
                    console.log(
                        '%cdata：' + (error.response == undefined ? error.name : error.response.config.data),
                        'background-color:#159E5C;color:white;height:16px;border-radius:4px;padding:2px 4px;'
                    )
                    console.log(
                        '%cerror：' + (error.response ? error.response.data.error : error.message),
                        'background-color:#DC5145;color:white;height:16px;border-radius:4px;padding:2px 4px;'
                    )
                    console.log(
                        '%cstatus：' + (error.response ? error.response.status : error.code),
                        'background-color:#FDCC41;color:white;height:16px;border-radius:4px;padding:2px 4px;'
                    )
                    console.log(
                        '%cmessage：' + error.message,
                        'background-color:#4D8BF2;color:white;height:16px;border-radius:4px;padding:2px 4px;'
                    )
                    console.log(
                        '%c-------------------------------------------------------------------',
                        'font-weight:700;'
                    )
                    console.groupEnd()
                    if (error.response) {
                        msg = status[error.response.status]
                    } else {
                        msg = error.message
                    }
                    reject(error)
                })
        })
    },
    //post请求
    post(url, param, x_api, header = { "Content-Type": "application/json" }) {
        delete param._rowKey
        delete param._index
        console.log(param);
        return new Promise((resolve, reject) => {
            service({
                method: 'post',
                url,
                x_api,
                header,
                data: param
            })
                .then((res) => {
                    // let urlList = url.split('/')
                    // console.log("TCL: post -> url", )
                    // if(urlList[urlList.length - 1]=='loginSelect'){

                    // }
                    console.log('res: ', res)
                    if ((res.status == 200 && res.data) || (res.status == 200 && res.data == null)) {
                        console.groupCollapsed('%c' + url + '  POST', 'font-weight:900;')
                        if (res.data && res.data instanceof Array) {
                            res.data.map((v) => {
                                console.log(
                                    '%cdataObj：' + JSON.stringify(v, null, 2),
                                    'background-color:#159E5C;color:white;height:16px;border-radius:4px;padding:2px 4px;'
                                )
                            })
                        } else if (res.data && res.data instanceof Object) {
                            console.log(
                                '%cdataObj：' + JSON.stringify(res.data, null, 2),
                                'background-color:#159E5C;color:white;height:16px;border-radius:4px;padding:2px 4px;'
                            )
                        } else if (res.data && res.data instanceof String) {
                            console.log(
                                '%cdata：' + res.data,
                                'background-color:#159E5C;color:white;height:16px;border-radius:4px;padding:2px 4px;'
                            )
                        } else if (res.data && res.data) {
                            console.log(
                                '%cdata：' + res.data,
                                'background-color:#159E5C;color:white;height:16px;border-radius:4px;padding:2px 4px;'
                            )
                        }
                        console.log(
                            '%c-------------------------------------------------------------------',
                            'font-weight:700;'
                        )
                        console.groupEnd()
                        if ((res.data && typeof res.data == 'string') || (res.data && res.data.msg)) {
                            // Message.success(res.data || res.data.msg)
                        }
                        resolve(res)
                    } else {
                        // Message.error(res.data.msg || '错误')
                        resolve(res)
                        reject(res.data.msg)
                    }
                })
                .catch((error) => {
                    if (process.env.NODE_ENV === 'production') return
                    console.dir(error)
                    console.group('%c' + url + '  POST', 'font-weight:900;color:red;')
                    console.log(
                        '%cdata：' + (error.response == undefined ? error.name : error.response.config.data),
                        'background-color:#159E5C;color:white;height:16px;border-radius:4px;padding:2px 4px;'
                    )
                    console.log(
                        '%cerror：' + (error.response ? error.response.data.error : error.message),
                        'background-color:#DC5145;color:white;height:16px;border-radius:4px;padding:2px 4px;'
                    )
                    console.log(
                        '%cstatus：' + (error.response ? error.response.status : error.code),
                        'background-color:#FDCC41;color:white;height:16px;border-radius:4px;padding:2px 4px;'
                    )
                    console.log(
                        '%cmessage：' + error.message,
                        'background-color:#4D8BF2;color:white;height:16px;border-radius:4px;padding:2px 4px;'
                    )
                    console.log(
                        '%c-------------------------------------------------------------------',
                        'font-weight:700;'
                    )
                    console.groupEnd()
                    if (error.response) {
                        msg = status[error.response.status]
                    } else {
                        msg = error.message
                    }
                    reject(error)
                })
        })
    },
    postPbf(url, param = {}, header = { "Content-Type": "application/json" }) {
        return new Promise((resolve, reject) => {
            service({
                method: "post",
                url,
                data: param,
                header,
                responseType: "arraybuffer"
            }).then((res) => {
                resolve(res)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    form(url, param = {}, type = 'post') {
        delete param._rowKey
        delete param._index
        let formData = new FormData()
        let keys = Object.keys(param)
        keys.map((v) => {
            formData.append(v, param[v])
        })
        return new Promise((resolve, reject) => {
            service({
                method: type,
                url,
                params: formData,
                data: formData
            })
                .then((res) => {
                    console.log('res: ', res)
                    if (
                        (res.status == 200 && res.data && res.data.code == 0) ||
                        (res.status == 200 && res.data == null)
                    ) {
                        console.groupCollapsed('%c' + url + '  POST', 'font-weight:900;')
                        if (res.data && res.data instanceof Array) {
                            res.data.map((v) => {
                                console.log(
                                    '%cdataObj：' + JSON.stringify(v, null, 2),
                                    'background-color:#159E5C;color:white;height:16px;border-radius:4px;padding:2px 4px;'
                                )
                            })
                        } else if (res.data && res.data instanceof Object) {
                            console.log(
                                '%cdataObj：' + JSON.stringify(res.data, null, 2),
                                'background-color:#159E5C;color:white;height:16px;border-radius:4px;padding:2px 4px;'
                            )
                        } else if (res.data && res.data instanceof String) {
                            console.log(
                                '%cdata：' + res.data,
                                'background-color:#159E5C;color:white;height:16px;border-radius:4px;padding:2px 4px;'
                            )
                        } else if (res.data && res.data) {
                            console.log(
                                '%cdata：' + res.data,
                                'background-color:#159E5C;color:white;height:16px;border-radius:4px;padding:2px 4px;'
                            )
                        }
                        console.log(
                            '%c-------------------------------------------------------------------',
                            'font-weight:700;'
                        )
                        console.groupEnd()
                        if ((res.data && typeof res.data == 'string') || (res.data && res.data.msg)) {
                            // Message.success(res.data || res.data.msg)
                        }
                        resolve(res)
                    } else {
                        // Message.error(res.data.msg || '错误')
                        resolve(res)
                        reject(res.data.msg)
                    }
                })
                .catch((error) => {
                    if (process.env.NODE_ENV === 'production') return
                    console.dir(error)
                    console.group('%c' + url + '  POST', 'font-weight:900;color:red;')
                    console.log(
                        '%cdata：' + (error.response == undefined ? error.name : error.response.config.data),
                        'background-color:#159E5C;color:white;height:16px;border-radius:4px;padding:2px 4px;'
                    )
                    console.log(
                        '%cerror：' + (error.response ? error.response.data.error : error.message),
                        'background-color:#DC5145;color:white;height:16px;border-radius:4px;padding:2px 4px;'
                    )
                    console.log(
                        '%cstatus：' + (error.response ? error.response.status : error.code),
                        'background-color:#FDCC41;color:white;height:16px;border-radius:4px;padding:2px 4px;'
                    )
                    console.log(
                        '%cmessage：' + error.message,
                        'background-color:#4D8BF2;color:white;height:16px;border-radius:4px;padding:2px 4px;'
                    )
                    console.log(
                        '%c-------------------------------------------------------------------',
                        'font-weight:700;'
                    )
                    console.groupEnd()
                    if (error.response) {
                        msg = status[error.response.status]
                    } else {
                        msg = error.message
                    }
                    reject(error)
                })
        })
    },
    delete(url, param = {}) {
        delete param._rowKey
        delete param._index
        return new Promise((resolve, reject) => {
            service({
                method: 'delete',
                url,
                params: param,
                cancelToken: new CancelToken((c) => {
                    cancel = c
                })
            })
                .then((res) => {
                    if (!res.data) {
                        resolve(res)
                        return
                    }
                    if (res.status == 200) {
                        resolve(res)
                    } else {
                        reject(res.data.msg)
                    }
                })
                .catch((error) => {
                    if (process.env.NODE_ENV === 'production') return
                    reject(error)
                })
        })
    },
    put(url, param = {}) {
        delete param._rowKey
        delete param._index
        return new Promise((resolve, reject) => {
            service({
                method: 'put',
                url,
                params: param,
                cancelToken: new CancelToken((c) => {
                    cancel = c
                })
            })
                .then((res) => {
                    if (res.status == 200) {
                        resolve(res)
                    } else {
                        resolve(res)
                        reject(res.data.msg)
                    }
                })
                .catch((error) => {
                    if (process.env.NODE_ENV === 'production') return
                    reject(error)
                })
        })
    },
}